import Subscribtion from '~/web-frontend-core/base/Subscribtion';
import { COLUMN_WIDTH, LOCK_STATE } from '~/web-frontend-core/api/const/base';
export default class HeadTable extends Subscribtion {
    constructor(width = COLUMN_WIDTH.MEDIUM) {
        super();
        this.width = width;
        this.data = new Map();
    }
    getData(matchID) {
        return this.data.get(matchID) || null;
    }
    update(matchID, config, data) {
        const prevData = this.getData(matchID);
        const isDisabled = typeof config.isDisabled !== 'undefined' ? config.isDisabled :
            typeof data.bl !== 'undefined' ? data.bl === LOCK_STATE.BLOCKED : !!prevData && prevData.isDisabled;
        /**
         * обновление headTable содержит только свойства ячеек, которые редко меняются
         * значения же коэф. берутся из outcomes.table,
         * которые обновляются вместе outcomes.headData в родителе Outcomes
         * Т.е необходимо перерисовавыться при каждом обновлении.
         */
        if ((data.headTable || []).length === 0 && (data.header || []).length === 0 && prevData) {
            prevData.isDisabled = isDisabled;
            this.notify(matchID);
            return;
        }
        ((data.tablesData || {}).headerTableColsVis || []).forEach(({ i }) => {
            data.headTable && data.headTable.forEach((row) => {
                row[i].additionalClassName = (row[i].st || '') + ' small_display_invisible';
            });
        });
        this.data.set(matchID, {
            headTable: (data.headTable || []).map((row) => row.slice(1).concat(row[0])),
            isDisabled,
        });
        this.notify(matchID);
    }
    clear() {
        this.data.clear();
        this.notify();
    }
    clearGame(matchID) {
        this.data.set(matchID, { headTable: [], isDisabled: false });
        this.notify();
    }
    deleteGame(matchID) {
        this.data.delete(matchID);
        this.notify();
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/outcomes/HeadTable.js